import React from 'react';
import { useTranslation } from 'react-i18next';

import { InputHandler } from '../../../../../viewer/input-handler';
import { SubscriptionTopic } from '../../../../../viewer/messaging/pubsub';
import { useNonce } from '../../../../hooks/use-nonce';
import { useSubscribe } from '../../../../hooks/use-subscribe';
import { ToolIcon } from '../tool-icon';
import { transformMode, transformState } from './utils';

const TranslateToolIcon = () => {
  const { t } = useTranslation();
  const [_, refresh] = useNonce();

  useSubscribe(SubscriptionTopic.NewSelection, refresh);
  useSubscribe(SubscriptionTopic.SetTool, refresh);

  return (
    <ToolIcon
      active={transformMode('translate')}
      callback={() => {
        InputHandler.instance.setTool('transform.translate');
        refresh();
      }}
      disabled={transformState('translate')}
      icon={['fal', 'arrows-up-down-left-right']}
      tooltip={{
        title: t('translate.tooltip.title', { ns: 'skyviewToolbar' }),
        text: t('translate.tooltip.text', { ns: 'skyviewToolbar' }),
      }}
    />
  );
};

export { TranslateToolIcon };
